import { makeStyles } from 'tss-react/mui';

import { colors } from '../../../../../styles/palette';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  icon: { marginRight: 5 },
  clearIcon: { position: 'absolute', zIndex: 1, right: 5 },
  errorIconSize: { minWidth: 20, cursor: 'initial' },
  checkBox: {
    marginBottom: theme.spacing(3),
    marginLeft: 0,
    '& .MuiSvgIcon-root': {
      height: 22,
      marginRight: 6,
      width: 22,
    },
    '& .MuiTypography-root': {
      fontSize: 18,
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiTypography-root': {
        fontSize: 16,
      },
    },
  },
  eventContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(8),
    '& > div:nth-child(3)': {
      '& input': {
        opacity: 0,
      },
    },
    '& > .MuiBox-root': {
      '&:nth-child(1)': {
        width: 350,
      },
      '&:nth-child(2)': {
        width: 114,
      },
      '&:nth-child(3)': {
        width: 280,
      },
    },
    [theme.breakpoints.down('lg')]: {
      '& > .MuiBox-root': {
        '&:nth-child(2)': {
          minWidth: 114,
        },
      },
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      marginBottom: theme.spacing(4),
      '& > .MuiBox-root': {
        '&:nth-child(1)': {
          width: '100% !important',
          '& > div:nth-child(2)': {
            maxWidth: 350,
            width: '100%',
          },
        },
        '&:nth-child(2)': {
          width: 76,
          minWidth: 'auto',
        },
        '&:nth-child(3)': {
          width: '100% !important',
        },
      },
    },
  },
  customPlaceholder: {
    paddingLeft: 6,
    paddingTop: 6,
    position: 'absolute',
    width: '100%',
    color: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
  },
  placeholderText: {
    width: '82%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.text.primary,
  },
  input: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 45,
  },
  fileInput: {
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.secondary.main,
      zIndex: '-1',
    },
    '& fieldset': {
      border: 'none',
    },
  },
  errorContainer: {
    display: 'flex',
    position: 'absolute',
  },
  errorIcon: {
    marginTop: 5,
    [theme.breakpoints.down('lg')]: {
      marginTop: 3.5,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 3,
    },
  },
  error: {
    color: colors.gilead.primary1,
    fontSize: 18,
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
}));
